import React, { memo } from "react";
import { Form, Checkbox } from "antd";
import classNames from "classnames";

import styles from "./styles.module.scss";
import { NamePath } from "antd/lib/form/interface";

interface ICheckboxGroup {
	checkAllTitle: string;
	category: string;
	options: any[];
	rules?: {}[];
	title?: string;
	/** Custom heading node — overrides `title` (e.g. "Tags * (choose up to 3)"). */
	titleNode?: React.ReactNode;
	/** Custom right-aligned node in the header (e.g. "2 / 3 selected"). */
	rightNode?: React.ReactNode;
	description?: any;
	disabled?: string;
	checkedValues?: string[];
	setValue?: (name: NamePath, value: any) => void;
}

const CheckboxGroup = Checkbox.Group;

const CheckboxGroupView: React.FunctionComponent<ICheckboxGroup> = (props) => {
	const {
		checkAllTitle,
		category,
		options,
		rules,
		title,
		titleNode,
		rightNode,
		description,
		disabled,
		checkedValues,
		setValue,
	} = props;
	return (
		<>
			<>
				<div className={styles.headerTags}>
					{(titleNode || title) && (
						<div
							className={classNames(styles.tagTitle, {
								// Custom titleNode renders its own asterisk.
								[styles.required]: rules && !titleNode,
							})}
						>
							{titleNode || title}
						</div>
					)}

					{rightNode && (
						<div className={styles.tagTitle}>{rightNode}</div>
					)}

					{!rightNode && checkAllTitle && options.length > 1 && (
						<div className={styles.allNoneContainer}>
							<Form.Item
								name={`${category}CheckAll`}
								valuePropName="checked"
							>
								<Checkbox
									defaultChecked={false}
									className={styles.checkBoxGroupGhost}
								>
									{category === "groups"
						? "Select all groups"
						: category === "audience"
						? "Select all member types"
						: "Select All"}
								</Checkbox>
							</Form.Item>
							<div style={{ color: "#aaa" }}>|</div>
							<Form.Item
								name={`${category}CheckNone`}
								valuePropName="checked"
							>
								<Checkbox
									defaultChecked={false}
									className={styles.checkBoxGroupGhost}
								>
									{"Clear"}
								</Checkbox>
							</Form.Item>
						</div>
					)}
				</div>
			</>
			{description}
			{category === "audience" ? (
				<Form.Item name={`${category}CheckboxGroup`} rules={rules}>
					{options.length > 0 &&
						options.map((opt: string) => {
							return (
								<Checkbox
									className={classNames(
										styles.checkBoxGroup,
										styles.accents,
									)}
									checked={
										checkedValues &&
										checkedValues.length > 0 &&
										checkedValues?.indexOf(opt) !== -1
									}
									disabled={opt === disabled}
									onChange={(event) => {
										if (setValue) {
											setValue(
												"audienceCheckboxGroup",
												event.target.checked
													? checkedValues?.concat(opt)
													: checkedValues?.filter(
															(e: string) =>
																e !== opt,
													  ),
											);
										}
									}}
								>
									{opt}
								</Checkbox>
							);
						})}
				</Form.Item>
			) : (
				<Form.Item name={`${category}CheckboxGroup`} rules={rules}>
					<CheckboxGroup
						className={classNames(
							styles.checkBoxGroup,
							styles.accents,
						)}
						options={options}
						onChange={(event) => {
							if (setValue) {
								setValue(category, event);
							}
						}}
					/>
				</Form.Item>
			)}
		</>
	);
};

export default memo(CheckboxGroupView);
